import React from 'react'
import { Grid, Typography, Chip, Box, Card, CardActionArea, CardContent, Button, Link } from '@material-ui/core'
import { Room } from '@material-ui/icons'
import { Trans } from 'react-i18next'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { pictureUrl } from '../common/pictureUrl'
import { getWilayasFromTranslation } from '../common/getWilayasFromTranslation'
import { useUpdate } from '../reducer'
import { useAuth, persistedFetch } from '../context/useFetch'

const StatusChip = (props) => <Chip color="secondary" variant="outlined" {...props} />

export const Post = ({ offer }) => {
  const router = useRouter()
  const companyId = offer.company.id
  const contractType = offer.contract_type.id

  const company = useSelector(({ offers: { included } }) => included.companies[companyId])
  const contract_type = useSelector(({ offers: { included } }) => included.contract_types[contractType])
  const WILAYAS = getWilayasFromTranslation()

  const getDepartmentName = (departmentCode) => WILAYAS.find(({ code }) => parseInt(code) === departmentCode).name


  const site = useSelector(({ site }) => site)

  if (!site) {
    return null
  }

  return (
    <Card className="actionArea">
      <CardActionArea
        component={Link}
        underline="none"
        style={{ color: 'inherit' }}
        onClick={() => router.push(`/job-offer/${offer.hashid}`)}
      >
        <CardContent className="geCard">

          {site.entity_type !== 'Company' && (
            <Grid className="grid two">
              <img
                alt={company.name}
                src={company.logo && pictureUrl(company.logo, 75 * 2, 75 * 2)}
                style={{ with: '64px', height: '64px' }}
              />

              <Grid>
                <Typography variant="h3">{company && company.name}</Typography>

                <Grid className="grid">
                  <Room style={{ fontSize: 16 }} />
                  <Typography>
                    {company && getDepartmentName(company.departement_code)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}

          <Grid container direction="column" spacing={1}>
            <Grid item>
              <Typography variant="h2">{offer.label}</Typography>
            </Grid>

            <Grid item>
              <Typography variant="body2" color="textSecondary">
                {contract_type.label}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {offer.remote !== 'never' && <span>#remote_{offer.remote}</span>}
              </Typography>
            </Grid>
          </Grid>

          <Grid container justifyContent="flex-end" alignItems="center">
            <Box>
              {['pending', 'draft'].includes(offer.status) && <StatusChip label={<Trans i18nKey="main.offer_status.draft" />} style={{ color: '#A9A9A9', borderColor: 'currentColor' }} />}
              {offer.status === 'rejected' && <StatusChip label={<Trans i18nKey="main.offer_status.rejected" />} style={{ color: '#ec5858', borderColor: 'currentColor' }} />}
              {offer.status === 'terminated' && <StatusChip label={<Trans i18nKey="main.offer_status.terminated" />} style={{ color: '#03A678', borderColor: 'currentColor' }} />}
              {offer.status === 'paused' && <StatusChip label={<Trans i18nKey="main.offer_status.paused" />} style={{ color: '#F7CA18', borderColor: 'currentColor' }} />}
              {offer.status === 'special' && <StatusChip label={<Trans i18nKey="main.offer_status.special" />} style={{ color: '#A9A9A9', borderColor: 'currentColor' }} />}

              <Button color="primary" variant="contained" style={{ marginLeft: '8px' }}>
                Postuler
              </Button>
            </Box>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card >
  )
}
